import React from 'react';
import styleable from 'react-styleable';
import Isvg from 'react-inlinesvg';
import GoldBarIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_star.svg';
import css from './activity-mastery-key-legends.scss';
import { translate } from '../../helpers/locale-helpers';

/**
 * Key Legends Component
 * Displays Static Gold bars and score bands
 */
const ActivityMasteryKeyLegends = () => {
    const legends = [
        { text: '86-100%', className: css['mastered-box'] },
        { text: '66-85%', className: css['consolidating-box'] },
        { text: '50-65%', className: css['developing-box'] },
        { text: '26-49%', className: css['emerging-box'] },
        { text: '0-25%', className: css['needsImproving-box'] }
    ];

    return (
        <div className={css.component}>
            <div className={css['gold-bars']}>
                <Isvg src={GoldBarIcon} cacheGetRequests />
                <div className={css.text}>{translate('Label - GoldBars')}</div>
            </div>
            {legends.map((legend) => (
                <div className={css.legend} key={legend.className}>
                    <div className={legend.className} />
                    <div className={css.text}>{legend.text}</div>
                </div>
            ))}
        </div>
    );
};

export default styleable(css)(ActivityMasteryKeyLegends);



// WEBPACK FOOTER //
// ./components/activity-mastery-key-legends/activity-mastery-key-legends.js